import { createSlice } from "@reduxjs/toolkit";

export interface VendorReviewToastSliceState {
  showToast: boolean;
}

const initialState: VendorReviewToastSliceState = {
  showToast: false,
};

export const vendorReviewToastSlice = createSlice({
  name: "vendorReviewToastSlice",
  initialState,
  reducers: {
    showPublishedVendorReviewToast: (state) => {
      state.showToast = true;
      return state;
    },
    hidePublishedVendorReviewToast: (state) => {
      state.showToast = false;
      return state;
    },
  },
});

export const { showPublishedVendorReviewToast, hidePublishedVendorReviewToast } = vendorReviewToastSlice.actions;
export default vendorReviewToastSlice;
